// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"fbe37caf","222":"c3a25fef","453":"462b5581","873":"f203090f"}[chunkId] + ".chunk.js";
};